import React from 'react'
import { AppStateType, useAppStateSelector } from '../Hooks/useAppState'

const XTwitter = () => {
    const darkMode = useAppStateSelector(AppStateType.APP, 'darkMode')
    return (
        <img
            css={{
                height: 24,
                width: 24,
                ...(darkMode
                    ? {
                          filter: `invert(1)`,
                      }
                    : null),
            }}
            src={'/static/icons/x-logo-black.svg'}
            title="Twitter / X"
        />
    )
}

export default React.memo(XTwitter)
